import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/card-online.png'
import _imports_1 from '@/assets/img/clubcard-gold.svg'
import _imports_2 from '@/assets/img/clubcard-loyalty.png'
import _imports_3 from '@/assets/img/my-qr-code-icon.svg'
import _imports_4 from '@/assets/img/try-again-icon.png'
import _imports_5 from '@/assets/img/lotuss-coin.png'
import _imports_6 from '@/assets/img/circle-info-gray-icon.svg'
import _imports_7 from '@/assets/img/gold-star-icon.svg'
import _imports_8 from '@/assets/img/star-green.png'


const _withScopeId = n => (_pushScopeId("data-v-02b9e23b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "clubcard-section"
}
const _hoisted_2 = { class: "clubcard-group" }
const _hoisted_3 = {
  key: 0,
  class: "clubcard-title"
}
const _hoisted_4 = { class: "clubcard-content-container" }
const _hoisted_5 = { class: "clubcard-content" }
const _hoisted_6 = { class: "clubcard-content-image-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clubcard-content-image",
  src: _imports_0
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "clubcard-content-image",
  src: _imports_1
}
const _hoisted_10 = {
  key: 2,
  class: "clubcard-content-image",
  src: _imports_2
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clubcard-content-image-qr-icon",
  src: _imports_3
}, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("QR ของฉัน ")
const _hoisted_13 = { class: "clubcard-content-image-arrow" }
const _hoisted_14 = { class: "clubcard-content-info-container" }
const _hoisted_15 = {
  key: 0,
  class: "clubcard-content-info-point-loading"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ball" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ball" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ball" }, null, -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "clubcard-content-info-point"
}
const _hoisted_21 = {
  key: 0,
  class: "clubcard-content-info-try-again-text"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" โหลดใหม่ ")
const _hoisted_23 = {
  key: 1,
  class: "clubcard-content-info-point-text"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clubcard-content-info-point-icon",
  src: _imports_5
}, null, -1))
const _hoisted_25 = {
  key: 2,
  class: "clubcard-content-info-point-tier"
}
const _hoisted_26 = { class: "clubcard-content-info-point-tier-text" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("คอยน์จะอัปเดตในวันถัดไป")
const _hoisted_28 = {
  key: 0,
  class: "clubcard-gold-tier-content"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gold-tier-badge" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }),
  /*#__PURE__*/_createTextVNode("Gold")
], -1))
const _hoisted_30 = { class: "gold-tier-text" }
const _hoisted_31 = {
  key: 1,
  class: "gold-upgrade-section"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"gold-tier-badge\" data-v-02b9e23b><img src=\"" + _imports_7 + "\" data-v-02b9e23b>Gold </div><div class=\"gold-upgrade-content\" data-v-02b9e23b><div class=\"upgrade-title\" data-v-02b9e23b>อัปเกรดมายโลตัส โกลด์ ได้แล้ว</div><div class=\"upgrade-subtitle\" data-v-02b9e23b>รับสิทธิพิเศษเหนือระดับมากมาย</div></div>", 2)
const _hoisted_34 = {
  key: 2,
  class: "lite-upgrade-section"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"upgrade-badge\" data-v-02b9e23b><img class=\"upgrade-badge-icon\" src=\"" + _imports_8 + "\" alt=\"\" data-v-02b9e23b><span data-v-02b9e23b>My Lotus’s</span></div><div class=\"upgrade-content\" data-v-02b9e23b><div class=\"upgrade-title\" data-v-02b9e23b>เริ่มต้นใช้งาน มายโลตัส</div><div class=\"upgrade-subtitle\" data-v-02b9e23b>ใช้คอยน์ แลกรีวอร์ด</div></div>", 2)
const _hoisted_37 = {
  key: 1,
  class: "clubcard-section"
}
const _hoisted_38 = { class: "clubcard-group" }
const _hoisted_39 = { class: "clubcard-content-container skeleton" }
const _hoisted_40 = { class: "clubcard-content" }
const _hoisted_41 = { class: "clubcard-content-image-container" }
const _hoisted_42 = { class: "clubcard-content-image-title" }
const _hoisted_43 = { class: "clubcard-content-info-container" }
const _hoisted_44 = { class: "clubcard-content-info-point" }
const _hoisted_45 = { class: "clubcard-content-info-point-text" }
const _hoisted_46 = { class: "clubcard-content-info-point-tier" }
const _hoisted_47 = {
  key: 0,
  class: "clubcard-gold-tier-content"
}
const _hoisted_48 = { style: {"width":"100%"} }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoadingPoints)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isFirstAccess())
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, "ขอบคุณสำหรับการเชื่อมต่อบัญชีของคุณ"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.isLite)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "clubcard-content-image-wrapper",
                        onClick: _cache[0] || (_cache[0] = $event => (_ctx.upgradeToLoyalty()))
                      }, _hoisted_8))
                    : (_ctx.store.state.tier?.tierName?.toLocaleLowerCase() === 'gold')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                      : (_openBlock(), _createElementBlock("img", _hoisted_10)),
                  _createElementVNode("div", {
                    class: "clubcard-content-image-title",
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.openModalBarcode()))
                  }, [
                    _hoisted_11,
                    _hoisted_12,
                    _createElementVNode("button", _hoisted_13, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_19))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_ctx.points === undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("img", {
                                class: "clubcard-content-info-try-again-icon",
                                src: _imports_4,
                                onClick: _cache[2] || (_cache[2] = $event => (_ctx.pointsRefresh()))
                              }),
                              _hoisted_22
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _hoisted_24,
                              _createTextVNode(" " + _toDisplayString(_ctx.getLabelPoints()), 1)
                            ])),
                        (_ctx.points !== 0 && _ctx.tieredPoints?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getLabelTieredPoints()), 1),
                              _createElementVNode("img", {
                                class: "clubcard-content-info-point-tier-icon",
                                src: _imports_6,
                                onClick: _cache[3] || (_cache[3] = $event => (_ctx.onShowTooltipTieredPoints()))
                              }),
                              _createElementVNode("span", {
                                class: _normalizeClass(['clubcard-content-info-point-tier-tooltip', {active: _ctx.isTooltipTieredPoints}])
                              }, [
                                _hoisted_27,
                                _createElementVNode("button", {
                                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.onCloseTooltipTieredPoints()))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                                ])
                              ], 2)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: "clubcard-content-info-point-history",
                          onClick: _cache[5] || (_cache[5] = $event => (_ctx.openCoinHistory()))
                        }, "ประวัติคอยน์")
                      ]))
                ])
              ]),
              (_ctx.store.state.tier?.tierName?.toLocaleLowerCase() === 'gold')
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, "สะสมยอดต่อเนื่องเพื่อรักษาสถานะ " + _toDisplayString(_ctx.getLabelGoldTierExpiryDate(_ctx.store.state.tier?.tierExpireDate)), 1),
                    _createElementVNode("div", {
                      class: "gold-tier-arrow",
                      onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.showModalGoldMember && _ctx.showModalGoldMember(...args)))
                    }, [
                      _createElementVNode("button", null, [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
                      ])
                    ])
                  ]))
                : (_ctx.store.state.tier?.eligibleTier?.tierName?.toLocaleLowerCase() === 'gold')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", {
                        class: "gold-upgrade-btn",
                        onTouchstart: _cache[7] || (_cache[7] = (...args) => (_ctx.clickShrink && _ctx.clickShrink(...args))),
                        onClick: _cache[8] || (_cache[8] = $event => (_ctx.upgradeCustomerTier()))
                      }, " อัปเกรด ", 32)
                    ]))
                  : (_ctx.isLite)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", {
                          class: "upgrade-btn",
                          onClick: _cache[9] || (_cache[9] = $event => (_ctx.upgradeToLoyalty()))
                        }, "ยืนยันตัวตน")
                      ]))
                    : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoadingPoints)
      ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_q_skeleton, {
                    class: "skeleton-img",
                    width: "102px",
                    height: "64px"
                  }),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-icon",
                      width: "12px",
                      height: "12px"
                    }),
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-title",
                      width: "77px",
                      height: "12px"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_q_skeleton, {
                        class: "skeleton-icon",
                        width: "20px",
                        height: "20px"
                      }),
                      _createVNode(_component_q_skeleton, {
                        class: "skeleton-title",
                        width: "172px",
                        height: "24px"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_q_skeleton, {
                        class: "skeleton-subtitle",
                        width: "158px",
                        height: "12px"
                      })
                    ]),
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-badge",
                      width: "72px",
                      height: "26px"
                    })
                  ])
                ])
              ]),
              (_ctx.store.state.tier?.tierName?.toLocaleLowerCase() === 'gold')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createVNode(_component_q_skeleton, {
                      class: "skeleton-badge",
                      width: "72px",
                      height: "26px"
                    }),
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_q_skeleton, {
                        class: "skeleton-title",
                        width: "100%",
                        height: "15px"
                      }),
                      _createVNode(_component_q_skeleton, {
                        class: "skeleton-subtitle",
                        width: "158px",
                        height: "12px"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}